import script from "./Departures.vue?vue&type=script&setup=true&lang=js"
export * from "./Departures.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Departures.vue?vue&type=style&index=1&id=8543f4b4&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8543f4b4"]])

export default __exports__